import { useSheetContext } from "@/context/sheet";
import { useCreateRegion } from "@/hooks/regions";
import { CreateRegion } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(regions)/regions/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateRegion({
    onSuccess: (region) => {
      close(() => {
        navigate({
          to: "/regions",
          params: { id: region.id.toString() },
        });
      });
    },
  });

  const create = async (region: CreateRegion) => {
    await mutateAsync(region);
  };

  return <Form onUpsert={create} />;
}
